import React from 'react';
import { Link } from 'react-router-dom';
import { RiArrowLeftWideLine, RiArrowRightWideLine } from 'react-icons/ri';
import '../styles/Navigator.css';

const Navigator = ({ links }) => {
  const [prev, next] = links;

  return (
    <nav className="navigator navigator--floating" aria-label="Photography sections">
      {prev && (
        <Link
          to={`/photography/${prev.toLowerCase()}`}
          className="navigator-side navigator-side--prev"
          aria-label={`Go to ${prev}`}
        >
          <RiArrowLeftWideLine className="navigator-arrow" />
          <span className="navigator-label">{prev}</span>
        </Link>
      )}
      {next && (
        <Link
          to={`/photography/${next.toLowerCase()}`}
          className="navigator-side navigator-side--next"
          aria-label={`Go to ${next}`}
        >
          <span className="navigator-label">{next}</span>
          <RiArrowRightWideLine className="navigator-arrow" />
        </Link>
      )}
    </nav>
  );
};

export default Navigator;
